import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import stylex from '@stylexjs/stylex';
import { getTextContrastColor } from '../../helpers/colors/getTextContrastColor';
import { createPolymorphicComponent } from '../../helpers/react/polymorphicComponentTypes';
import { isValidHexColor } from '../../helpers/colors/isValidHexColor';
import { useStyles } from '../../hooks/useStyles';
import { Base } from '../Base';
import { colorTagTokens, colorTagTheme } from './ColorTag.stylex';
import { colorTagStyles } from './ColorTag.styles';
const localStyles = stylex.create({
    backgroundColor: (color) => ({
        [colorTagTokens.containerColor]: color,
    }),
    foregroundColor: (color) => ({
        [colorTagTokens.labelTextColor]: color,
        [colorTagTokens.iconColor]: color,
    }),
});
export const ColorTag = createPolymorphicComponent(forwardRef(function ColorTag(props, forwardedRef) {
    const { styles, sx, children, label, icon, backgroundColor, foregroundColor, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'ColorTag',
        styles: [colorTagStyles, styles],
    });
    const foregroundColorHex = foregroundColor ??
        (backgroundColor ? getTextContrastColor(backgroundColor) : undefined);
    const isEmpty = !backgroundColor;
    const isInvalid = !!backgroundColor && !isValidHexColor(backgroundColor);
    return (_jsxs(Base, { ...other, sx: [
            colorTagTheme,
            globalStyles,
            backgroundColor && isValidHexColor(backgroundColor)
                ? localStyles.backgroundColor(backgroundColor)
                : undefined,
            foregroundColorHex
                ? localStyles.foregroundColor(foregroundColorHex)
                : undefined,
            combineStyles('host', isEmpty && 'host$empty', isInvalid && 'host$invalid'),
            sx,
        ], ref: forwardedRef, children: [icon ? (_jsx("div", { ...getStyles('icon'), children: icon })) : label ? (_jsx("div", { ...getStyles('label'), children: label })) : null, children] }));
}));
